import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { LoadingState } from '@practium/ui';
import { useExchangeHandoff } from '@practium/features/api';

export const AuthExchangePageAdmin = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const { mutateAsync: exchangeHandoff } = useExchangeHandoff();
	const hasExchanged = useRef(false);

	useEffect(() => {
		if (hasExchanged.current) return;
		hasExchanged.current = true;

		const code = searchParams.get('code');

		if (!code) {
			navigate('/login', { replace: true });
			return;
		}

		exchangeHandoff(code)
			.then(() => navigate('/', { replace: true }))
			.catch(() => navigate('/login', { replace: true }));
	}, [exchangeHandoff, navigate, searchParams]);

	return <LoadingState fullScreen />;
};
